<template>
  <div class="login-header">
    <h1 class="header-title">
      {{ $route.meta.title }}
    </h1>

    <slot />
  </div>
</template>
